exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app>*{-webkit-box-sizing:border-box!important;box-sizing:border-box!important}", ""]);

// exports
